import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import ApiBasketItemPerson from "../../../../../core/api/api.basketItemPerson";
import publicApi from "../../../../../core/api/api.public";
import SwalMessage from "../../../_Components/SwalMessage";

import Swal from "sweetalert2";

function CancelOrderModal({
  showModalCancle,
  setShowModalCancle,
  selectedCheckBoxes,
}) {
  const [basketCancelTypes, setBasketCancelTypes] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    // defaultValues: {
    //   cancelType: 0,
    //   description: "",
    // },
  });

  useEffect(() => {
    (async () => {
      const result = await publicApi.getEnumValues({
        enumName: "BasketCancelType",
      });
      if (result?.succeeded) {
        setBasketCancelTypes(result.data);
      }
    })();
  }, []);

  const handleClose = () => {
    setShowModalCancle(false);
  };

  const onSubmit = async (data) => {
    if (selectedCheckBoxes.length === 0) return;

    const payload = {
      cancelType: data.cancelType,
      description: data.description,
      basketItemPersonList: selectedCheckBoxes,
    };

    const response = await ApiBasketItemPerson.cancleBasketItemPerson(payload);
    if (response && response.data) {
      console.log("sss : ", response);
      // ساخت و نمایش پیغام خروجی
      let HtmlOutPut = response.data
        .map((item) => {
          return (
            "<div class='border rounded-3 text-end py-2 px-4 mb-5 " +
            (item.status == true
              ? "bg-light-success border-light-success text-dark-success-msg-box"
              : "bg-light-danger border-light-danger text-dark-danger-msg-box") +
            "'>" +
            "<span> " +
            item.nameItem +
            " </span> | " +
            "<span class='" +
            (item.status == true ? "text-success " : "text-danger") +
            "'> ثبت درخواست کنسلی  " +
            (item.status == true ? "انجام شد" : "انجام نشد") +
            " </span><div> " +
            item.message +
            "</div></div>"
          );
        })
        .join("");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success  mr-2 px-5 ",
          cancelButton: "btn btn-danger px-5 ",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons.fire({
        title: "عملیات درخواست کنسلی",
        icon: "info",
        html: HtmlOutPut,
        type: "success",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "  بستن ",
      });

      // ویرایش دیتا های روی صفحه پشتی
      //props.data.callBack();

      // بستن مدال
      handleClose();

      document.getElementById("submitButton").click();
    } else
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  };

  return (
    <Modal
      onHide={handleClose}
      show={showModalCancle}
      size="md"
      fullscreen="md-down"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>درخواست استرداد</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col xs="12" className="px-1 mb-2 fs-085">
          درخواست استرداد برای شماره بلیط‌های:
        </Col>
        <Col className="px-0 d-flex align-items-center flex-wrap mb-3">
          {selectedCheckBoxes.map((item, index) => (
            <div
              key={index}
              className="px-2 bg-light ms-2 border py-1 mb-2 rounded-pill"
            >
              {item}
            </div>
          ))}
        </Col>

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* انتخاب دلیل کنسل کردن */}
          <Card className="bg-light">
            <Card.Body>
              <Row className="my-0 py-0">
                <Col xs="12" className="px-1 fw-bold mb-2 fs-085">
                  <span className={errors.cancelType ? "text-danger" : ""}>
                    1. علت کنسلی چیست؟
                  </span>
                </Col>
              </Row>
              <Row className="d-flex justify-content-between">
                {basketCancelTypes.map((item) => (
                  <Col
                    xs="6"
                    key={item.value}
                    className="my-1 px-1"
                    onClick={() => setValue("cancelType", parseInt(item.value))}
                  >
                    <Controller
                      control={control}
                      name="cancelType"
                      render={({ field }) => (
                        <div
                          className={
                            field.value === parseInt(item.value)
                              ? "py-2 d-flex justify-content-center px-0 fs-07 rounded-2 border border-primary text-primary bg-white cursor-pointer"
                              : "py-2 d-flex justify-content-center rounded-2 fs-07 border text-muted px-0 bg-white cursor-pointer"
                          }
                        >
                          {item.title}
                        </div>
                      )}
                    />
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>

          {/* فیلد توضیحات */}
          <Card className="mt-3 bg-light">
            <Card.Body>
              <Row className="px-0">
                <Col xs="12" className="px-1">
                  <Form.Group>
                    <Form.Label className="text-dark fw-bold mb-2">
                      2. درج توضیحات
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      className={`py-3 my-0 rounded-2 fs-08 ${errors.description ? "border-danger" : ""}`}
                      placeholder="متن توضیحات"
                      {...register("description")}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* دکمه‌ها */}
          <Row className="mt-3 pb-3">
            <Col xs="auto">
              <Button
                type="submit"
                variant="success"
                size="sm"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <Spinner animation="border" variant="warning" size="sm" />
                )}
                ثبت درخواست استرداد
              </Button>
            </Col>
            <Col xs="auto" className="pe-0">
              <Button onClick={handleClose} variant="danger" size="sm">
                انصراف
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default CancelOrderModal;
